import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { PrType, ProductTypeService, PrTypeData } from '../../services/product-type.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-create-pr-c-type',
  templateUrl: './create-pr-c-type.component.html',
  styleUrls: ['./create-pr-c-type.component.css']
})
export class CreatePrCTypeComponent implements OnInit {

  errorCode: string;

  prTypeForm: FormGroup;
  reportSelect: any[];

  constructor(
    private prTypeService: ProductTypeService,
    private data: PrTypeData,
    private fb: FormBuilder,
  ) {
    this.reportSelect = Utils.array(this.data.reports).map(([name, value]) => ({value, name}));
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.prTypeForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      code: ['',Validators.required],
      report: 'key0'
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.selection = 'compra';
    let sub = this.prTypeService.codeExistCompra(value.code).subscribe(data => {
      sub.unsubscribe();
      if(!data.length){
        this.prTypeService.addPrType(value);
        /* if(value.code.length == 4){
          this.prTypeService.addPrType(value);
        }else{
          this.errorCode='El código debe de ser de cuatro letras'
        } */
      }else{
        this.errorCode='Este código ya existe, seleccione otro.';
      }
 
    })
    
  }

}
